module.exports = __webpack_public_path__ + "static/media/bi.3cc0e802.JPG";